var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PacemEventTarget, Watch, PropertyConverters, Utils } from './_default-imports';
import { Debounce } from '../../decorators';
//namespace Pacem.Components {
let PacemMetaProxyElement = class PacemMetaProxyElement extends PacemEventTarget {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        this._update();
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._update();
    }
    _update() {
        const value = this.content;
        const nameBased = !Utils.isNullOrEmpty(this.name);
        const key = nameBased ? this.name : this.itemprop;
        if (Utils.isNullOrEmpty(key) || this.disabled) {
            // No key means do nothing
            return;
        }
        const escapedKey = Utils.cssEscape(key);
        const query = nameBased ? `meta[name='${escapedKey}']` : `meta[itemprop='${escapedKey}']`;
        var meta = document.head.querySelector(query);
        if (Utils.isNull(meta)) {
            meta = document.createElement('meta');
            document.head.appendChild(meta);
        }
        else if (Utils.isNullOrEmpty(value)) {
            // Empty `content` means "remove the element".
            meta.remove();
            return;
        }
        // set
        meta.setAttribute("content", value);
        meta.setAttribute(nameBased ? "name" : "itemprop", key);
        meta.removeAttribute(nameBased ? "itemprop" : "name");
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemMetaProxyElement.prototype, "name", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemMetaProxyElement.prototype, "itemprop", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemMetaProxyElement.prototype, "content", void 0);
__decorate([
    Debounce(true)
], PacemMetaProxyElement.prototype, "_update", null);
PacemMetaProxyElement = __decorate([
    CustomElement({
        tagName: P + '-meta-proxy'
    })
], PacemMetaProxyElement);
export { PacemMetaProxyElement };
//}
